module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "striiv-sleep-stages"
    }
  }, [(!_vm.striivData.error) ? _c('mu-card', [_c('mu-divider'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time asleep",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.total)
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Stages of sleep",
      "subTitle": _vm.date
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', [_c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Deep")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.deep)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.deep) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Light")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.light)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.light) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Awake")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.awake) + "x")])])], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/striiv.png"
    }
  }), _vm._v("\n          Data from Striiv\n        ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.striivData.error) ? _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "No data",
      "subTitle": _vm.date
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7363052b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graphs/Sleep/StriivSleepStages.vue
// module id = 3225
// module chunks = 1